import { Container, Grid } from "@material-ui/core"
import { useTranslation } from "react-i18next"
import { HeaderHLPure, GridPure, ButtonHLPure, Question, CheckBoxHLPure } from "../../pures"
import { PanelBar, PanelBarItem } from "@progress/kendo-react-layout"
import './survey-details.css'
import { useState, useEffect } from "react"

const SurveyDetailsView = (props) => {
  const { t, i18n } = useTranslation('survey', { keyPrefix: 'surveyInfoScreen' })
  const { t: tCommon } = useTranslation('common');

  const { publicityData: {
    title,
    startDate,
    url,
    endDate,
    description,
    imagePath,
    minAge,
    maxAge,
    surveyConsumerPreferences,
    surveyGenders,
    surveyBranchOffices,
    questions,
    perVisit,
    perBranch
  },
    typeQuestion } = props;

  const formattedStartDate = /^\d{4}-\d{2}-\d{2}$/.test(startDate) ? startDate.split('-').reverse().join('/') : startDate.split('-').join('/')
  const formattedEndDate = /^\d{4}-\d{2}-\d{2}$/.test(endDate) ? endDate.split('-').reverse().join('/') : endDate.split('-').join('/')
  const consumerPreferences = surveyConsumerPreferences.map(({ consumerPreference }) => consumerPreference.name)
  const branchOffices = surveyBranchOffices.map(({ branchOffice }) => branchOffice)

  const [branchOfficesSurvey, setBranchOfficesSurvey] = useState(branchOffices);
  const [preferences, setPreferences] = useState([])
  const [genders, setGenders] = useState()

  useEffect(() => {
    if (consumerPreferences) {
      const auxPreferences = consumerPreferences.map((consumerPreference) => {
        return tCommon(consumerPreference.trim())
      })

      setPreferences(auxPreferences)
    }

    if (surveyGenders) {
      const auxGenders = surveyGenders.map((surveyGender) => {
        return tCommon(surveyGender.gender.name)
      }).join(', ')

      setGenders(auxGenders)
    }
  }, [i18n.language])

  return (
    <div className="publicityDetailsView">
      <Container>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <HeaderHLPure title={t("mainTitle")} />
          </Grid>

          <Grid item xs={12}>
            <Container maxWidth={"md"}>
              <Grid container spacing={4}>
                <Grid item xs={12}>
                  <PanelBar>
                    <PanelBarItem title={t("expansionTitle1")} expanded>
                      <Grid container spacing={4} className="indentation-panel">
                        <Grid item xs={12} className="publicityDetailsView-column">
                          <p>
                            <span className="field-label">{t("surveyName")}</span>
                            <span className="field-value">{title}</span>
                          </p>
                          <p>
                            <span className="field-label">{t("surveyDescription")}</span>
                            <span className="field-value">{description}</span>
                          </p>
                        </Grid>

                        <Grid item xs={12} className="publicityDetailsView-row">
                          <CheckBoxHLPure disabled labelCheckBox={t("perVisit")} checkedState={perVisit} />
                          <CheckBoxHLPure disabled labelCheckBox={t("perBranch")} checkedState={perBranch} />
                        </Grid>

                        <Grid item xs={6} className="publicityDetailsView-column">
                          <p>
                            <span className="field-label">{t("surveyStartDate")}</span>
                            <span className="field-value">{formattedStartDate}</span>
                          </p>
                        </Grid>
                        <Grid item xs={6} className="publicityDetailsView-column">
                          <p>
                            <span className="field-label">{t("surveyEndDate")}</span>
                            <span className="field-value">{formattedEndDate}</span>
                          </p>
                        </Grid>
                      </Grid>
                    </PanelBarItem>

                    <PanelBarItem title={t("expansionTitle2")}>
                      <Grid container spacing={4} className="indentation-panel">
                        <Grid item xs={12}>
                          <p className="field-label">{t("surveyConsumerPreferences")}</p>
                          <ul className="field-value preferences-list">
                            {preferences.map((item, index) => (
                              <li key={index} className="list-items">{item}</li>
                            ))}
                          </ul>
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <p>
                            <span className="field-label">{t("surveyGenders")}</span>
                            <span className="field-value">{genders}</span>
                          </p>
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <p>
                            <span className="field-label">{t("surveyAges")}</span>
                            <span className="field-value">{minAge} {t("surveyAgesTo")} {maxAge} {t("surveyAgesRange")}</span>
                          </p>
                        </Grid>
                        <Grid item xs={12} style={{ display: 'grid' }}>
                          <p className="field-label">{t("surveyBranchOffices")}</p>
                          <GridPure
                            {...props}
                            dataGrid={branchOfficesSurvey}
                            setData={setBranchOfficesSurvey}
                            skip={0}
                            take={11}
                            rowsItems={[{
                              field: 'keyIdentifier',
                              sorteable: true,
                              title: t("surveyBranchOfficesKeyIdentifier"),
                              width: '20%'
                            },
                            {
                              field: 'name',
                              sorteable: true,
                              title: t("surveyBranchOfficesName"),
                              width: '40%'
                            }]}
                          />
                        </Grid>
                      </Grid>
                    </PanelBarItem>
                    <PanelBarItem title={t("expansionTitle3")}>
                      <Grid container spacing={4} className="indentation-panel">
                        <Grid container>
                          <Grid item lg={12} md={12} xs={12}>
                            {
                              questions.map((question, key) => {
                                //Map para volver a convertir el maxDate y minDate a Objeto tipo Date
                                const updatedQuestion = {
                                  ...question,
                                  config: question.config
                                    ? {
                                      ...question.config,
                                      maxDate: question.config.maxDate ? new Date(question.config.maxDate) : null,
                                      minDate: question.config.minDate ? new Date(question.config.minDate) : null
                                    }
                                    : question.config
                                };
                                return (
                                  <Question
                                    typeQuestion={typeQuestion}
                                    data={updatedQuestion}
                                    id={key}
                                    lastQuestion={questions.length - 2}
                                    justShowDetails
                                  />
                                )
                              })
                            }
                          </Grid>
                        </Grid>
                      </Grid>
                    </PanelBarItem>
                  </PanelBar>
                </Grid>

                <Grid item xs={12} className="button-actions">
                  <ButtonHLPure
                    colorScheme="secondary" outlined
                    nameBtn={t("viewAnswers")}
                    onClick={props.goToAnswers}
                  />
                  <ButtonHLPure
                    primary outlined
                    nameBtn={t("surveyReturnButton")}
                    onClick={() => { props.handleReturn('/surveys') }}
                  />
                </Grid>
              </Grid>
            </Container>
          </Grid>
        </Grid>
      </Container>
    </div>
  )
}

export { SurveyDetailsView as default }